import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@heroui/react";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { apiRoute, linksUrl } from "../../constants/enum";
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components";
import { COLUMN_ALIGN_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable";
import { toast } from "react-toastify";
import ConfirmBox from "../../components/ConfirmBox";
import { setDetailParams, setNewEntryMode } from "../../state/itemTypeEntrySlice";


const ItemTypeMaster = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);

    const [itemToDelete, setItemToDelete] = useState("")

    // Fetch shape data
    const {
        data,
        isPending,
        isError,
        mutate:filterData
    } = usePost({
        url: apiRoute.itemType.fetch,
        queryKey: "fetchItemTypeMaster",
    });

    const funLoadData = () => {
        filterData({
            data: {}
        })
    }
    useEffect(() => {
        funLoadData();
    }, [])


    const onSuccessDelete = () => {
       setItemToDelete("")
       funLoadData()
    };

    // Delete shape mutation
    const { mutate: fnDelete } = usePost({
        url: apiRoute.itemType.deleteEntry,
        queryKey: "deletetypeMaster",
        onSuccessTasks: onSuccessDelete,
        //successMessage: "Item Group deleted successfully!",
    });

    const exportColumns = [
       
        {
            name: "Item Type",
            uid: "Item_Type_Name",
        },
        {
            name: "St Per",
            uid: "StPer",
        },
       {
            name: "Ast Per",
            uid: "AstPer",
        },
        {
            name: "Hsn No.",
            uid: "HsnNo",
        },
        

    ]

     let downloadDataFooter = {
        Item_Type_Name: "",
        StPer: "",
        AstPer: "",
        HsnNo:""
    }

    const handleConfirmBox = (data) => {
        if (data) {
            fnDelete({ data:{item_typeid: itemToDelete}});
        }
        else
        setItemToDelete("")
    };
    
    const handleAddNew = () => {
        dispatch(setNewEntryMode(true));
        dispatch(setDetailParams([])); 
        navigate(linksUrl.master.itemType.createItemTypeMaster);
    };

    

    const columns = [
        { name: "Actions", uid: "actions", align: COLUMN_ALIGN_TYPE.center },
        { name: "Type Name", uid: "Item_Type_Name", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "St Per", uid: "StPer", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Ast Per", uid: "AstPer", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "HSn No", uid: "HsnNo", sortable: true, align: COLUMN_ALIGN_TYPE.center },
    ];

    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon icon={faEdit} style={{ color: "#379906" }} />,
            onClick: (row) => {
                let obj={
                    item_typeid:row.Item_Type_Id
                };
                dispatch(setDetailParams(obj));
                dispatch(setNewEntryMode(false))
                navigate(linksUrl.master.itemType.createItemTypeMaster);
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon icon={faTrash} style={{ color: "#c40c18" }} />,
            onClick: (row) => {
                setItemToDelete(row.Item_Type_Id)
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
    ];        

    if (isPending) return <LoadingCard/>;
    if (isError) return <ErrorCard/>;

    return (
        <div>
            <MainContainer pageName="Item Type" breadcrumbs={["Mater", "Item Type Master"]}>
                <div className="text-right mb-4">
                    <Button size="sm" color="primary" startContent={<FontAwesomeIcon icon={faPlus} />} onPress={handleAddNew}>
                        Add New
                    </Button>
                </div>
                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={["actions", "Item_Type_Name", "StPer", "AstPer", "HsnNo"]}
                    data={data}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    showAdvanceFilter={false}
                    exportColumns={exportColumns}
                    downloadDataFooter={downloadDataFooter}
                    downloadFileName="ItemType-master-List"
                    id="Item_Type_Id"
                    
                />
            </MainContainer>

            {itemToDelete && itemToDelete!="" && <ConfirmBox handleConfirmBox={handleConfirmBox} />}
        </div>
    );
};

export default ItemTypeMaster;
